import { render, staticRenderFns } from "./submitQuestion.vue?vue&type=template&id=01995468&"
import script from "./submitQuestion.vue?vue&type=script&lang=js&"
export * from "./submitQuestion.vue?vue&type=script&lang=js&"
import style0 from "./submitQuestion.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports